import type { Translate } from "./i18n";
import type { CheckErrorCode } from "./types";

const CODES: CheckErrorCode[] = [
  "blocked",
  "http",
  "timeout",
  "network",
  "unknown",
];

/**
 * Dựng câu mô tả lỗi check theo ngôn ngữ đang chọn.
 *
 * Server chỉ gửi **mã lỗi** (`errorCode`) cùng vài tham số; câu chữ do phía
 * hiển thị tự dựng — nhờ vậy đổi ngôn ngữ CMS là câu lỗi đổi theo, thay vì luôn
 * hiện nguyên câu tiếng Việt server đã dựng sẵn. Bot Telegram/Lark làm y hệt ở
 * `check-link-app-api/src/common/check-error.ts` — sửa câu chữ thì sửa cả hai.
 *
 * `fallback` là chuỗi lỗi thô (`error`) — dùng cho bản ghi cũ chưa có mã lỗi,
 * hoặc chuỗi do app mobile tự gửi lên.
 */
export function describeCheckError(
  t: Translate,
  info: {
    code?: CheckErrorCode | string | null;
    statusCode?: number | null;
    detail?: string | null;
  },
  fallback: string | null = null,
): string | null {
  const code = info.code as CheckErrorCode;
  if (!code || !CODES.includes(code)) return fallback;

  const detail = info.detail?.trim() || null;
  // Thiếu chi tiết thì "Lỗi mạng: " / "Quá thời gian chờ sau ms" vô nghĩa.
  const key: CheckErrorCode =
    (code === "network" || code === "timeout") && !detail ? "unknown" : code;

  return t(`check.err.${key}`, {
    status: info.statusCode == null ? "?" : info.statusCode,
    detail: detail ?? "?",
  });
}
